// * Create by jiangjijing on 2020/3/2
import Vue from 'vue'
import Router from 'vue-router'
import authority from './authority'
import driverConfig from './driverConfig'
import outPutConfig from './outPutConfig'
import vehicleConfig from './vehicleConfig'
import saleConfig from './saleConfig'
import dataView from './dataView'
import usedCar from './usedCar'
import recruit from './recruit'
import warehouseConfig from './warehouseConfig'
import advConfig from './advConfig'
import financeConfig from './financeConfig'
Vue.use(Router)
// 登陆页
const Login = resolve => require(['@/views/login.vue'], resolve)
// 首页
const home = resolve => require(['@/views/home.vue'], resolve)
const childMenu = [
  ...driverConfig,
  ...outPutConfig,
  ...vehicleConfig,
  ...authority,
  ...saleConfig,
  ...dataView,
  ...usedCar,
  ...recruit,
  ...warehouseConfig,
  ...advConfig,
  ...financeConfig
]

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: { requireAuth: true },
      children: [...childMenu]
    }

  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // window.addEventListener('load', function () {
  //   router.app.$options.store.dispatch('SET_LOCATION_HASH', window.location.hash.split('#')[1])
  //   if (from.path == '/') {
  //     next({path: router.app.$options.store.getters.GET_LOCATION_HASH})
  //   } else {
  //     next({path: from.path})
  //   }
  // })
  // if (to.path != '/login') {
  //   if (to.path == '/home' || to.path == '/homeView') {
  //     next()
  //   } else if (to.path == '/budgetInfo' || to.path == '/budgetPrepayInfo') {
  //     if (api.sGetObject('bgPayId') || api.sGetObject('workPayId')) {
  //       next()
  //     } else {

  //     }
  //   } else {
  //     if (commonFunc.checkRouter(to.path)) {
  //       if (to.matched.some(res => res.meta.requireAuth)) { // 判断是否需要登录权限
  //         var userCode = api.sGetObject('userCode')
  //         var token = api.sGetObject('token')
  //         if (userCode && token) { // 判断是否登录
  //           next()
  //         } else { // 没登录则跳转到登录界面
  //           next({path: '/'})
  //         }
  //       } else {
  //         next()
  //       }
  //     } else {
  //       next({path: '/'})
  //     }
  //   }
  // } else {
  //   next()
  // }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js